import React from "react";
import {createRoot} from "react-dom/client";
import _ from '@app/utils.js'

export default class ComponentBootstrapper {
  components = {}

  constructor(components) {
    this.components = components
    this.boot()
  }

  /**
   * Al document ready monta i componenti react e registra un behavior per permettere a drupal di rimontare i
   * componenti presenti nelle sezioni di html caricate via ajax.
   *
   * @see https://www.drupal.org/docs/drupal-apis/javascript-api/javascript-api-overview
   */
  boot() {
    _.onDocumentReady(() => {
      this.mountUnmountedInContext(document)

      window.Drupal.behaviors.diemmebiReactComponents = {
        attach: (context) => this.mountUnmountedInContext(context),
      }
    })
  }

  /**
   * Monta i componenti trovati dentro `context`. Ogni componente viene montato al più una volta usando once.
   * @see https://www.npmjs.com/package/@drupal/once
   * @param {Document|Element} context
   */
  mountUnmountedInContext(context) {
    const elements = window.once('diemmebi-react-component', '[data-react-component]', context)

    elements.forEach(el => {
      const componentName = el.dataset.reactComponent
      const componentProps = el.dataset.reactComponentProps ?? "{}"
      const Component = this.components[componentName]
      const props = JSON.parse(componentProps)
      createRoot(el).render(<Component {...props} />);
    });
  }
}
